import { render, staticRenderFns } from "./EventViewPage.vue?vue&type=template&id=4068f5c9"
import script from "./EventViewPage.vue?vue&type=script&lang=js"
export * from "./EventViewPage.vue?vue&type=script&lang=js"
import style0 from "./EventViewPage.vue?vue&type=style&index=0&id=4068f5c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports